import {
    AdDefinition,
    createRegisterableComponent,
} from '@news-mono/web-common'
import React from 'react'
import {
    AdUnitWrapper,
    AdUnitWrapperProps,
} from '../../advertising/AdUnit/AdUnitWrapper'

export type AdUnitRouteProps = Omit<AdUnitWrapperProps, 'onEvent'> & {
    slot: AdDefinition
}

export const AdUnitRegistration = createRegisterableComponent(
    'ad-unit',
    (
        {
            slot,
            breakout,
            hiddenUntilLoaded,
            noticePosition,
            padding,
            stickyOffset,
            unitRendered,
            preventCollapse,
            adType,
        }: AdUnitRouteProps,
        services,
    ) => {
        return (
            <AdUnitWrapper
                adState={services.adState}
                unitId={slot.id}
                onEvent={services.onEvent}
                breakout={breakout}
                hiddenUntilLoaded={hiddenUntilLoaded}
                noticePosition={noticePosition}
                padding={padding}
                stickyOffset={stickyOffset}
                unitRendered={unitRendered}
                preventCollapse={preventCollapse}
                adType={adType}
            />
        )
    },
)
